// extracted by mini-css-extract-plugin
export default {"FullPage":"disabled_FullPage__XwdWz"};